import React from 'react';
import PropTypes from 'prop-types';
import Text from '../components/Text';

const Page = ({ pageData }) => <Text dangerouslySetInnerHTML={{__html: pageData.text}} />;

Page.propTypes = {
  pageData: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default Page;
